module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    ref: "wrap",
    class: ['vue-slider-component', _vm.flowDirection, _vm.disabledClass, {
      'vue-slider-has-label': _vm.piecewiseLabel
    }],
    style: (_vm.wrapStyles),
    on: {
      "click": _vm.wrapClick
    }
  }, [_c('div', {
    ref: "elem",
    staticClass: "vue-slider",
    style: ([_vm.elemStyles, _vm.bgStyle]),
    attrs: {
      "aria-hidden": "true"
    }
  }, [(_vm.isRange) ? [_c('div', {
    ref: "dot0",
    class: [_vm.tooltipStatus, 'vue-slider-dot'],
    style: ([_vm.dotStyles, _vm.sliderStyles[0]]),
    on: {
      "mousedown": function($event) {
        return _vm.moveStart($event, 0)
      },
      "touchstart": function($event) {
        return _vm.moveStart($event, 0)
      }
    }
  }, [_c('span', {
    class: ['vue-slider-tooltip-' + _vm.tooltipDirection[0], 'vue-slider-tooltip-wrap']
  }, [_vm._t("tooltip", function() {
    return [_c('span', {
      staticClass: "vue-slider-tooltip",
      style: (_vm.tooltipStyles[0])
    }, [_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val[0]) : _vm.val[0]))])]
  }, {
    "value": _vm.val[0],
    "index": 0
  })], 2)]), _vm._v(" "), _c('div', {
    ref: "dot1",
    class: [_vm.tooltipStatus, 'vue-slider-dot'],
    style: ([_vm.dotStyles, _vm.sliderStyles[1]]),
    on: {
      "mousedown": function($event) {
        return _vm.moveStart($event, 1)
      },
      "touchstart": function($event) {
        return _vm.moveStart($event, 1)
      }
    }
  }, [_c('span', {
    class: ['vue-slider-tooltip-' + _vm.tooltipDirection[1], 'vue-slider-tooltip-wrap']
  }, [_vm._t("tooltip", function() {
    return [_c('span', {
      staticClass: "vue-slider-tooltip",
      style: (_vm.tooltipStyles[1])
    }, [_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val[1]) : _vm.val[1]))])]
  }, {
    "value": _vm.val[1],
    "index": 1
  })], 2)])] : [_c('div', {
    ref: "dot",
    class: [_vm.tooltipStatus, 'vue-slider-dot'],
    style: ([_vm.dotStyles, _vm.sliderStyles]),
    on: {
      "mousedown": _vm.moveStart,
      "touchstart": _vm.moveStart
    }
  }, [_c('span', {
    class: ['vue-slider-tooltip-' + _vm.tooltipDirection, 'vue-slider-tooltip-wrap']
  }, [_vm._t("tooltip", function() {
    return [_c('span', {
      staticClass: "vue-slider-tooltip",
      style: (_vm.tooltipStyles)
    }, [_vm._v(_vm._s(_vm.formatter ? _vm.formatting(_vm.val) : _vm.val))])]
  }, {
    "value": _vm.val
  })], 2)])], _vm._v(" "), _c('ul', {
    staticClass: "vue-slider-piecewise"
  }, _vm._l((_vm.piecewiseDotWrap), function(piecewiseObj, index) {
    return _c('li', {
      key: index,
      staticClass: "vue-slider-piecewise-item",
      style: ([_vm.piecewiseDotStyle, piecewiseObj.style])
    }, [_vm._t("piecewise", function() {
      return [(_vm.piecewise) ? _c('span', {
        staticClass: "vue-slider-piecewise-dot",
        style: ([_vm.piecewiseStyle, piecewiseObj.inRange ? _vm.piecewiseActiveStyle : null])
      }) : _vm._e()]
    }, {
      "label": piecewiseObj.label,
      "index": index,
      "first": index === 0,
      "last": index === _vm.piecewiseDotWrap.length - 1,
      "active": piecewiseObj.inRange
    }), _vm._v(" "), _vm._t("label", function() {
      return [(_vm.piecewiseLabel) ? _c('span', {
        staticClass: "vue-slider-piecewise-label",
        style: ([_vm.labelStyle, piecewiseObj.inRange ? _vm.labelActiveStyle : null])
      }, [_vm._v("\n            " + _vm._s(piecewiseObj.label) + "\n          ")]) : _vm._e()]
    }, {
      "label": piecewiseObj.label,
      "index": index,
      "first": index === 0,
      "last": index === _vm.piecewiseDotWrap.length - 1,
      "active": piecewiseObj.inRange
    })], 2)
  }), 0), _vm._v(" "), _c('div', {
    ref: "process",
    staticClass: "vue-slider-process",
    style: (_vm.processStyle)
  })], 2), _vm._v(" "), (!_vm.isRange && !_vm.data) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    staticClass: "vue-slider-sr-only",
    attrs: {
      "type": "range",
      "min": _vm.min,
      "max": _vm.max
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "__r": function($event) {
        _vm.val = $event.target.value
      }
    }
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc50d98e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-slider-component/src/vue2-slider.vue
// module id = 3280
// module chunks = 1